import React, { type FC, type ReactNode } from 'react';
import { cssMap } from '@compiled/react';

import { Inline, Text } from '@atlaskit/primitives/compiled';
import EyeOpenIcon from '@atlaskit/icon/core/eye-open';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		boxSizing: 'border-box',
		backgroundColor: token('elevation.surface.sunken'),
		borderRadius: token('radius.small'),
		minHeight: '48px',
		width: '100%',
		padding: token('space.150'),
		paddingLeft: token('space.100'),
		display: 'flex',
		alignItems: 'center',
	},
	iconContainer: {
		width: '24px',
		height: '24px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
});

const IconContainer: FC<{ children: ReactNode }> = ({ children }) => (
	<div css={styles.iconContainer}>{children}</div>
);

export interface NotifyOnlyBoxProps {
	text: string;
}

export const NotifyOnlyBox: FC<NotifyOnlyBoxProps> = ({ text }) => {
	return (
		<div css={styles.container}>
			<Inline alignBlock="center" spread="space-between" grow="fill">
				<Inline alignBlock="center" space="space.150">
					<IconContainer>
						<EyeOpenIcon label="" color={token('color.icon.subtle')} />
					</IconContainer>
					<Text maxLines={6}>{text}</Text>
				</Inline>
			</Inline>
		</div>
	);
};
